/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLastActivityResource } from './userLastActivityResource';
import { UserLastActivity200ResponseMeta } from './userLastActivity200ResponseMeta';


export interface UserLastActivity200Response { 
    data: UserLastActivityResource;
    meta: UserLastActivity200ResponseMeta;
}

